const types = ["NO_LABEL", "SELLER_LABEL", "AMAZON_LABEL"];
const LabelPrepTypes = types.map((value) => ({
    value,
    text: value,
}));

export default LabelPrepTypes;
